// extracted by mini-css-extract-plugin
export default {"linkContainer":"U-OgD","linkText":"YvFXS","skeleton-progress":"a5YaS"};